/**
 * DEPRECATED: Chat store module - Brief Coach chat feature
 * This module is DEAD CODE - chatService methods are commented out
 * Actions in this module will fail if called because chatService has no active methods
 * Block comment pending - keeping structure for reference
 * 2024-01 - Dead code cleanup
 */
import { chatService } from '@/services/chatService'

export default {
    namespaced: true,
    state: {
        chat: null,
        loading: false,
        error: null,
        pollingInterval: null,
        currentSessionId: null,
        previousSessionId: null, // Track previous session ID to detect changes
        pollingEnabled: true
    },
    getters: {
        getChat: state => state.chat,
        getMessages: state => state.chat?.messages || [],
        getMessageCount: state => state.chat?.messages?.length || 0,
        isLoading: state => state.loading,
        getError: state => state.error,
        isPolling: state => !!state.pollingInterval,
        getCurrentSessionId: state => state.currentSessionId,
        isPollingEnabled: state => state.pollingEnabled
    },
    mutations: {
        SET_CHAT(state, chat) {
            state.chat = chat
        },
		SET_ADD_CHAT_MESSAGE(state, message) {
			if (state.chat) { state.chat.messages.unshift(message)} //push
		},
        SET_LOADING(state, loading) {
            state.loading = loading
        },
        SET_ERROR(state, error) {
            state.error = error
        },
        CLEAR_ERROR(state) {
            state.error = null
        },
        SET_POLLING_INTERVAL(state, intervalId) {
            state.pollingInterval = intervalId
        },
        SET_CURRENT_SESSION(state, sessionId) {
            state.previousSessionId = state.currentSessionId
            state.currentSessionId = sessionId
        },
        SET_PREVIOUS_SESSION(state, sessionId) {
            state.previousSessionId = sessionId
        },
        SET_POLLING_ENABLED(state, enabled) {
            state.pollingEnabled = enabled
        }
    },
    actions: {
        async getSessionChat({ commit, state }, sessionId) {
            // Only show loading if we're changing to a different session
            const isChangingSession = state.currentSessionId !== sessionId
            if (isChangingSession) {
                commit('SET_LOADING', true)
            }
            commit('CLEAR_ERROR')

            try {
                const chat = await chatService.getSessionChat(sessionId)
                commit('SET_CHAT', chat)
                commit('SET_CURRENT_SESSION', sessionId)
                return chat
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch chat history'
                commit('SET_ERROR', errorMessage)
                throw error
            } finally {
                if (isChangingSession) {
                    commit('SET_LOADING', false)
                }
            }
        },

        async pollForNewMessages({ commit, state, dispatch, rootGetters }) {
            if (!state.currentSessionId || !state.pollingEnabled) {
                return
            }


            try {
                const chat = await chatService.getSessionChat(state.currentSessionId)
                if (chat?.messages) {
                    // Simply replace the entire chat object
                    // Vue's reactivity will handle the rest
                    commit('SET_CHAT', chat)
                }
                // Check if session is ready and stop polling if so
                if (rootGetters['session/isSessionReady']) {
                    console.log('Session is ready, stopping chat polling')
                    dispatch('stopPolling')
                    return chat
                }
            } catch (error) {
                console.error('Polling error:', error)
				return
                // Don't throw error for polling - just log it
            }

        },

        startPolling({ commit, dispatch, state }, sessionId) {
            // Stop any existing polling
            dispatch('stopPolling')

            // Set current session
            commit('SET_CURRENT_SESSION', sessionId)

            // Only start polling if it's enabled
            if (state.pollingEnabled) {
                // Start polling every 3 seconds
                const intervalId = setInterval(() => {
                    dispatch('pollForNewMessages')
                }, 3000)

                commit('SET_POLLING_INTERVAL', intervalId)
            }
        },

        stopPolling({ commit, state }) {
            if (state.pollingInterval) {
                clearInterval(state.pollingInterval)
                commit('SET_POLLING_INTERVAL', null)
            }
        },

        async submitMessage({ commit, dispatch }, { sessionId, chatInput }) {
            commit('SET_LOADING', true)
            commit('CLEAR_ERROR')

            try {
				console.log("submitting message")
                const response = await chatService.submitMessage(sessionId, chatInput)
				if (response?.chat) {
                    // only sent back if new session (enables ability to add submitted user message faster instead of waiting for polls)
                    commit('SET_CHAT', response.chat)
                }
				if(response?.userChatDTO){
					console.log(`received userChatDTO`)
					commit('SET_ADD_CHAT_MESSAGE', response.userChatDTO)
				}

                // Optimistically bump the session's updatedAt so it moves to the top
                dispatch('session/touchSession', { sessionId, updatedAt: response?.timestamp }, { root: true })

                return response
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || 'Failed to submit message'
                commit('SET_ERROR', errorMessage)
                throw error
            } finally {
                commit('SET_LOADING', false)
            }
        },

        togglePolling({ commit, state, dispatch }, enabled) {
            commit('SET_POLLING_ENABLED', enabled)

            if (enabled && state.currentSessionId) {
                dispatch('startPolling', state.currentSessionId)
            } else if (!enabled) {
                dispatch('stopPolling')
            }
        },

        clearChat({ commit, dispatch }) {
            dispatch('stopPolling')
            commit('SET_CHAT', null)
            commit('CLEAR_ERROR')
            commit('SET_CURRENT_SESSION', null)
            commit('SET_PREVIOUS_SESSION', null)
        },

    }
}